<template>
  <div id="app">
    <navbar></navbar>
    <keep-alive>
      <router-view />
    </keep-alive>
    <FooterN />
  </div>
</template>

<script>
import Navbar from '@/components/header/navbar'
import FooterN from '@/components/footer/FooterN'
export default {
  name: 'App',
  components: {
    Navbar,
    FooterN
  }
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.text-title {
  /* font-size: 40px; */
  font-size: 2.25rem;
}
.text-desc {
  padding: 30px 0;
  margin-bottom: 0;
  color: #555;
}
</style>



// WEBPACK FOOTER //
// src/App.vue